$('form[action="/cart/add"]').on('submit', function(event) {
  event.preventDefault(); // prevent default form submission
  var $form = $(this);
  var $button = $form.find('.add-to-cart-btn');
  
  $button.addClass('btn--loading');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $form.serialize(),
    dataType: 'json',
    async: true,
    success: function() {
      // Open the cart drawer after successfully adding the product
      // theme.CartDrawer.open();
      $('#CartDrawer').addClass('drawer--is-open');
    },
    error: function() {
      console.error('Error adding product to cart');
    },
   complete: function() {
      $button.removeClass('btn--loading');
    }
  });
});